import Vue from "vue";
import Router from "vue-router";
import NProgress from "nprogress";
import routes from "./routes";
import store from "../store";

Vue.use(Router);

const options = {
  mode: "history",
  base: process.env.BASE_URL,
  routes: routes
};

const router = new Router(options);

router.beforeEach((to, from, next) => {
  // update title
  window.document.title = process.env.VUE_APP_TITLE;
  // '/' will be redirected to home page or login page
  // NProgress won't be stopped if it's a self-redirect  
  if (to.path !== "/") NProgress.start();
  
  // block unsupported devices
  if ((to.name == "unsupportedDevice" && store.getters.belowMobileCutoff && store.getters.userPrefsFullscreen))
      next("/");
  else if(to.name != "unsupportedBrowser" && store.getters.isIE && store.getters.restrictInIE){
    next("unsupportedBrowser");
  } 
  else if (to.name != "unsupportedDevice" && to.name != "emrstat" && store.getters.belowMobileCutoff && !store.getters.userPrefsFullscreen && !store.getters.isFullscreen) {
    next("unsupportedDevice");
  }
  // block un-authenitcated access to internal pages
  else if (to.matched.some(route => route.meta.requiresAuth) && !store.getters.isAuthenticated)
    next({ path: "/", query: { redirect: to.path } });
  else next();
});

router.afterEach(() => {
  NProgress.done();
  // store.commit("destroyStatus");
  store.commit("tryDisplayDelayedStatus");
});

router.history.getCurrentLocation = function(){
  let path = window.location.pathname;
  let base = router.history.base;

  if (base && path.toLowerCase().indexOf(base.toLowerCase()) === 0){
    path = path.slice(base.length);
  }

  return (path || "/") + window.location.search + window.location.hash;
}

export default router;
